module.exports = __webpack_public_path__ + "static/media/Cercle.be350864.svg";